var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCassiopeiaBadgeIsReferral = function SvgCassiopeiaBadgeIsReferral(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.891,
    height: 36.038,
    viewBox: "0 0 5.527 9.535",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.673 18.93a.432.432 0 0 1 .01-.461l1.266-1.914-1.727-1.48a.432.432 0 0 1-.089-.55l1.24-2.066a2.816 2.816 0 0 0-1.738-.602 2.842 2.842 0 0 0-2.766 3.487c.395 2.452 3.12 5.039 5.074 5.75a1.04 1.04 0 0 1 .023-.01z",
    style: {
      fill: "#d1a600",
      fillOpacity: 1,
      stroke: "#5a4800",
      strokeWidth: 0.287999,
      strokeOpacity: 1
    },
    transform: "translate(-15.649 -11.713)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.119 18.945c-.168-.671.628-1.32 1.177-2.281-.658-.5-.947-.827-1.427-1.286-.27-.26-.38-.614-.195-.936l.989-1.729c-.52-.331-.874-.436-1.36-.34-1.323.26-1.806.937-2.012 2.195-.02 2.178 1.87 4.15 3.505 5.504-.314-.492-.563-.719-.677-1.127z",
    style: {
      fill: "#dd2e44",
      fillOpacity: 1,
      stroke: "#8c0000",
      strokeWidth: 0.222754,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    transform: "translate(-15.649 -11.713)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.875 13.182c-1.538 1.238-.526 3.172.265 4.078.367.421.457.634-.137.189-.98-.844-2.076-3.172-.475-4.275.805-.554.76-.324.347.008z",
    style: {
      fill: "#fff",
      fillOpacity: 0.5,
      strokeWidth: 0.265112,
      strokeLinejoin: "round",
      strokeDasharray: ".795337,.265112",
      strokeDashoffset: 0.291624,
      strokeOpacity: 0.5
    },
    transform: "translate(-15.649 -11.713)"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCassiopeiaBadgeIsReferral);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cassiopeia-badge-is-referral.5b586025b9b14e6bcc7a4e40f7a160ee.svg";